import detector from 'detector';
import md5 from 'md5';

const device = {
    deviceOs: `${detector.os.name}${detector.os.fullVersion}`,
    deviceName: detector.device.name,
    deviceId: md5(navigator.userAgent),
    appVersion: navigator.appVersion
};
export default { ...detector, ...device };
